import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartbeat } from "@fortawesome/free-solid-svg-icons";

const PageLoader = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-[#EEF3FA]">
      <div className="relative text-center animate-page-loader">
        <div className="absolute left-1/2 top-1/2 h-56 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/80 blur-2xl" />
        <div className="relative">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#1562EE] shadow-[0_12px_30px_rgba(21,98,238,0.28)]">
            <FontAwesomeIcon
              icon={faHeartbeat}
              className="text-[24px] text-white"
            />
          </div>
          <h1 className="font-[Gilroy-Bold] text-[34px] text-[#152C55]">
            HealthSure
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
